import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { strings } from "../../Translations/strings";
import "../Auth.scss";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import InputError from "../../Common/Error/InputError";
import { resetPassword } from "./lib";

const ResetPasswordForm = ({ onSuccessChange }) => {
  const [resetInProgress, setResetInProgress] = useState(false);
  const [resetSuccess, setResetSuccess] = useState(false);
  const [resetError, setResetError] = useState(null);
  const navigation = useNavigate();

  useEffect(() => {
    if (onSuccessChange) {
      onSuccessChange(resetSuccess);
    }
  }, [resetSuccess, onSuccessChange]);

  const schema = yup.object().shape({
    email: yup
      .string()
      .required(strings.validation_field_required_label)
      .email(strings.validation_field_email),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: "",
    },
  });

  const onSubmit = async (data) => {
    setResetInProgress(true);
    setResetError(null);
    
    try {
      await resetPassword(data.email);
      setResetInProgress(false);
      setResetSuccess(true);
    } catch (err) {
      setResetInProgress(false);
      setResetError("Greška pri slanju email-a. Molimo pokušajte ponovo.");
    }
  };

  const errorStyle = {
    display: "block",
    marginTop: "0px !important",
    textAlign: "center",
  };

  if (resetSuccess) {
    return (
      <div className="reset-success-container">
        <h3 className="reset-success-title">{strings.reset_password_success_title}</h3>
        <p className="reset-success-message">{strings.reset_password_success_message}</p>
        <Button
          variant="primary"
          className="submit-form-register"
          onClick={() => navigation("/login")}
        >
          Nazad na prijavu
        </Button>
      </div>
    );
  }

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group className="mb-3 required" controlId="formBasicEmail">
          <Form.Label aria-required className="control-label">
            {strings.email_input_label}
          </Form.Label>
          <Form.Control
            type="email"
            isInvalid={errors?.email?.message}
            onKeyPress={(e) => {
              if (e.code === "Space" || e.keyCode === 32) {
                e.preventDefault();
              }
            }}
            placeholder={strings.email_input_placeholder}
            {...register("email", { required: true })}
          />
          <Form.Control.Feedback type="invalid">
            {errors?.email?.message}
          </Form.Control.Feedback>
        </Form.Group>
        
        {resetError && <InputError message={resetError} style={errorStyle} />}
        
        <Button
          variant="primary"
          className="submit-form-register"
          type="submit"
        >
          {resetInProgress ? (
            <div className="spinner-border text-light" role="status"></div>
          ) : (
            strings.reset_password_button_label
          )}
        </Button>
      </Form>
    </>
  );
};

export default ResetPasswordForm;
